export default __webpack_public_path__ + "static/media/file13.b8141214.jpg";